import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchShipmentFees } from '../../actions/shipmentsActions';

const useShipmentFees = (shipmentId: string) => {
	const dispatch = useDispatch<any>();
	const { shipmentFees, shipmentFeesLoading, shipmentFeesError } = useSelector(
		({ shipmentsReducer }) => shipmentsReducer
	);

	useEffect(() => {
		if (!shipmentFees[shipmentId]) dispatch(fetchShipmentFees(shipmentId));
	}, [shipmentFees, shipmentId, dispatch]);

	return {
		shipmentFees,
		shipmentFeesLoading,
		shipmentFeesError,
	};
};

export default useShipmentFees;
